/*
 * Project: BookingEngine
 * Module: Policy.js
 * @flow
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';

import { BOOKING_STEP, setStep, getHotelDetails } from '../../actions/Booking';
import { getLangValue } from '../../utils/Generic';

import '../../static/images/loading5.gif';
import '../../static/less/hotel/policy.less';
import withNavigate from '../../withNavigate'; // Importa el HOC

/* Este componente se enlaza desde el bono de la reserva */
class Policy extends React.Component {
  state: { hotel?: null };

  constructor(props) {
    super(props);
    this.state = { hotel: null };
  }

  componentDidMount() {
    const { lang, hotelId } = this.props.params;
    this.props.dispatch(setLanguage(lang));

    // Llamada asincrónica y actualización del estado
    this.props.dispatch(getHotelDetails(hotelId)).then((response) => {
      this.setState({ hotel: response });
    });

    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
  }

  renderPolicies() {
    return (
      <div className="PolicyContent">
        <h1>{this.context.t('General Conditions')}</h1>
        {/* eslint-disable react/no-danger */}
        <p dangerouslySetInnerHTML={{ __html: getLangValue(this.state.hotel, this.props.lang, 'policies') }}/>
        {/* eslint-enable react/no-danger */}
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="row">
        <div className="col-md-12 col-sm-12 Loading">
          <img src="/img/loading5.gif"/>
          <p>{this.context.t('Loading hotel policies...')}</p>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="Policy container">
        {this.state.hotel ? this.renderPolicies() : this.renderLoading()}
      </div>
    );
  }
}

Policy.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
});

const ConnectedPolicy = connect(mapStateToProps)(Policy);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedPolicy);
